import { JobTimeModel } from '../ts/interfaces/models/JobTimeModel';
import { BaseService } from './baseService';

class JobTimeService extends BaseService<JobTimeModel> {
  controllerName = 'jobTimes';
}

export const jobTimeService = new JobTimeService();
